import { render, staticRenderFns } from "./SimilarRecommendation.vue?vue&type=template&id=045f2f78&scoped=true"
import script from "./SimilarRecommendation.vue?vue&type=script&lang=js"
export * from "./SimilarRecommendation.vue?vue&type=script&lang=js"
import style0 from "./SimilarRecommendation.vue?vue&type=style&index=0&id=045f2f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045f2f78",
  null
  
)

export default component.exports